export default function formatCurrency(amount: number, forceDecimals?: boolean): string {
  if (amount % 1 > 0 || forceDecimals) {
    return `$${amount.toFixed(2)}`;
  } else {
    return `$${amount}`;
  }
}
